export const setPolishValidationMessage = (e) => {
  const input = e.target;
  
  if (input.validity.valueMissing) {
    const messages = {
      email: 'Wprowadź adres email',
      password: 'Wprowadź hasło',
      text: 'Wypełnij to pole',
      tel: 'Wprowadź numer telefonu',
      date: 'Wybierz datę',
      time: 'Wybierz godzinę',
      number: 'Wprowadź liczbę',
    };
    input.setCustomValidity(messages[input.type] || 'Wypełnij to pole');
  } 
  else if (input.validity.typeMismatch) {
    const messages = {
      email: 'Wprowadź poprawny adres email',
      tel: 'Wprowadź poprawny numer telefonu',
    };
    input.setCustomValidity(messages[input.type] || 'Niepoprawny format');
  }
  else if (input.validity.patternMismatch) {
    input.setCustomValidity(input.getAttribute('data-error') || 'Niepoprawny format');
  }
  else if (input.validity.tooShort) {
    input.setCustomValidity(`Minimum ${input.minLength} znaków`);
  }
  else if (input.validity.tooLong) {
    input.setCustomValidity(`Maksimum ${input.maxLength} znaków`);
  }
  else {
    input.setCustomValidity('Niepoprawna wartość');
  }
};
export const clearValidationMessage = (e) => {
  e.target.setCustomValidity('');
};
